<template>
	<div class="page-content signage egl-dialog-elm">
		<h1 class="page-title">{{ $locale("signage.title")}}</h1>
		<p>{{$locale("signage.url")}}</p>
		<p>{{form.url}}</p>
    <p>{{ form.urlV2 }}</p>
		<p class="form-title">{{$locale("signage.informationSettings")}}</p>
		<el-form class="rule-form" :model="form" ref="signageForm">
			<el-row>
				<el-col :span="4">
					<el-form-item prop="filmRemarkDisplay" :label="$locale('signage.workRemarks')">
						<el-select v-model="form.filmRemarkDisplay">
							<el-option :label="$locale('global.yes')" :value="true"></el-option>
							<el-option :label="$locale('global.no')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="4">
					<el-form-item prop="filmRemarkDisplay" :label="$locale('signage.restrict')">
						<el-select v-model="form.ethicalDisplay">
							<el-option :label="$locale('global.yes')" :value="true"></el-option>
							<el-option :label="$locale('global.no')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="10">
					<el-form-item prop="alertMessage">
						<span slot="label">
							{{$locale('signage.notification')}}
							<span style="font-size: 12px">{{$locale("signage.notification.tips")}}</span>
						</span>
						<el-input v-model="form.alertMessage" />
					</el-form-item>
				</el-col>
			</el-row>
			<p class="form-title">{{$locale("signage.switchSetting")}}</p>
			<el-row :gutter="20">
				<el-col :span="4">
					<el-form-item prop="switchStartPage" :label="$locale('signage.switchSetting.page')">
						<el-input v-model="form.switchStartPage" />
					</el-form-item>
				</el-col>
				<el-col :span="4">
					<el-form-item prop="switchSecond" :label="$locale('signage.switchSetting.second')">
						<el-input v-model="form.switchSecond" />
					</el-form-item>
				</el-col>
			</el-row>
			<!-- <el-row :gutter="20" v-for="(item, idx) in form.switchTypeList" :key="idx">
				<el-col :span="4">
					<el-form-item prop="type" :label="$locale('purchase.inventoryChangeType')">
						<el-select
							v-model="item.type"
              @change="() => item.url = ''"
						>
							<el-option
								:label="$locale('signage.switchSetting.type.trailer')"
								value="PREVIEW"
							/>
							<el-option
								:label="$locale('signage.switchSetting.type.photo')"
								value="PORTRAIT"
							/>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12" v-if="item.type === 'PREVIEW' || item.type === ''">
					<el-form-item :prop="`switchTypeList[${idx}].url`" :label="$locale('setting.cinema.trailer.link')" :rules="rules.url">
						<el-input v-model="item.url" />
					</el-form-item>
				</el-col>
        <el-col :span="item.type === 'PORTRAIT' ? 4 : 12" v-else>
         <UploadContainer
            :type="'B'"
            :imageList="[item.url]"
            @onSuccess="({response}) => uploadSuccess(response, idx)"
            @onDelete="deleteImg"
          />
        </el-col>
        <el-col :span="4" v-if="item.type === 'PORTRAIT'">
          <el-form-item :prop="`switchTypeList[${idx}].showSecond`" :label="$locale('signage.switchSetting.showSecond')" :rules="rules.showSecond">
            <el-input v-model="item.showSecond" />
          </el-form-item>
        </el-col>
				<el-col :span="4">
					<el-form-item :prop="`switchTypeList[${idx}].sort`" :label="$locale('global.order')" :rules="rules.sort">
						<el-input v-model="item.sort" />
					</el-form-item>
				</el-col>
				<el-col :span="4" :style="{ 'display':'flex'}">
					<div class="operation" v-if="form.switchTypeList.length > 1" @click="minus(idx)">
						<i class="el-icon-minus"></i>
					</div>
					<div class="operation" v-if="form.switchTypeList.length === 1 || idx === form.switchTypeList.length - 1" @click="plus">
						<i class="el-icon-plus"></i>
					</div>
				</el-col>
			</el-row> -->
      <el-row :gutter="20" class="dialog-footer" style="margin-top: 89px;">
          <el-col :span="24">
            <el-button class="egl-btn-white">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
		</el-form>
	</div>
</template>

<script>
import UploadContainer from "@/components/common/UploadContainer";
import { createSinageService, signageDetailService, updateSignageService } from "@/helpers/service/api/signage";
import countDownAlert from "@/utils/countDownAlert";

export default {
  data() {
    return {
      file: [],
      scrollTop: 0,
      form: {
        filmRemarkDisplay: true,
        ethicalDisplay: true,
        alertMessage: "",
        switchSecond: 0,
        switchStartPage: 1,
        switchTypeList: [ {
          type: "PORTRAIT",
          url: "",
          sort: 0,
          showSecond: 0,
        } ],
        url: "",
        urlV2: "",
      },
      rules: {
        url: [ {
          required: true, message: this.$locale("signage.switchSetting.plsInputUrl"), trigger: "blur"
        } ],
        sort: [ {
          required: true, message: this.$locale("signage.switchSetting.plsInputSort"), trigger: "blur"
        } ],
        showSecond: [ {
          required: true, message: this.$locale("signage.switchSetting.plsInputShowSecond"), trigger: "blur"
        } ]
      }
    };
  },
  created() {
    window.addEventListener("scroll",this.initHeight);
    this.getDetail();
  },
  methods: {
    initHeight() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    getDetail() {
      signageDetailService({
        cinemaId: window.localStorage.getItem("cinemaId"),
        page: 0,
        pageSize: 9999
      }).then(res => {
        // console.log(res.data);
        if(res.data) {
          this.form = { ...res.data };
        }
      });
    },
    plus() {
      this.form.switchTypeList.push({
        type: "",
        url: "",
        sort: 0,
        showSecond: 0,
      });
    },
    minus(idx) {
      if (this.form.switchTypeList.length > 1) {
        this.form.switchTypeList.splice(idx, 1);
      }
    },
    deleteImg(idx) {
      this.form.switchTypeList[idx].url = "";
    },
    uploadSuccess(res, idx) {
      if (res.success) {
        this.form.switchTypeList[idx].url = res.data;
      }
      this.file = [];
    },
    save_fn() {
      this.$refs.signageForm.validate(valid => {
        if (valid) {
          updateSignageService({
            ...this.form,
            cinemaId: window.localStorage.getItem("cinemaId"),
            id: this.form.id || "",
          }).then(res => {
            if (res.data) {
              countDownAlert({
                content: this.form.id ? this.$locale("global.updateSuccessfully") : this.$locale("global.createSuccessfully"),
                callback: () => {
                  this.getDetail();
                }
              });
            }
          });
          // if (!this.form.switchTypeList.every(item => item.type)) {
          //   this.$alert(this.$locale("signage.switchSetting.plsSelectType"), "", {
          //     lockScroll: false
          //   });

          // } else if (this.form.switchTypeList.some(item => item.type === "PORTRAIT" && !item.url)) {
          //   this.$alert(this.$locale("signage.switchSetting.plsSelectPhoto"), "", {
          //     lockScroll: false
          //   });
          // } else {
          //   updateSignageService({
          //     ...this.form,
          //     cinemaId: window.localStorage.getItem("cinemaId"),
          //     id: this.form.id || "",
          //   }).then(res => {
          //     if (res.data) {
          //       countDownAlert({
          //         content: this.form.id ? this.$locale("global.updateSuccessfully") : this.$locale("global.createSuccessfully"),
          //         callback: () => {
          //           this.getDetail();
          //         }
          //       });
          //     }
          //   });
          // }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    }
  },
  components: {
    UploadContainer,
  }
};
</script>
<style lang="less" scoped>
	.form-title {
		font-size: 16.8px;
	}
	.operation {
		cursor: pointer;
		box-sizing: border-box;
		width: 40px;
		height: 40px;
		border: 1px solid #ddd;
		border-radius: 3px;
		margin-top: 40px;
		margin-right: 12px;
		line-height: 40px;
		text-align: center;
		i {
			color: #979797;
		}
	}
  .upload-container {
  display: inline-block;

  .upload-component {
    display: inline-block;

    & +.el-button {
      margin-left: 10px;
    }
  }

  .image-list {
    list-style: none;
    margin: 0;
    padding: 0;

    > li {
      display: inline-block;
      width: 160px;
      height: 160px;
      margin: 10px 20px 10px 0;
      border: 2px solid transparent;
      background-color: #f8f8f8;

      .el-image {
        width: 100%;
        height: 100%;
      }

      &:last-child {
        margin-right: 0;
      }

      &.delSelected {
        position: relative;
        border: 2px solid @primary-red;
        background-color: @pure-white;

        &::before {
          content: "";
          position: absolute;
          z-index: 2;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: rgba(255, 255, 255, .3);
        }
      }

      ::v-deep .image-slot {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;

        > i {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -1.5rem;
          margin-left: -1.5rem;
          font-size: 3rem;
        }
      }
    }
  }

  .upload-img {
    display: inline-block;
    position: relative;
    // width: 230px;
    // height: 230px;
    min-width: 60px;
    min-height: 60px;
    margin-right: 20px;
    background: @light-grey-bg;
    overflow: hidden;

    &:last-child {
      margin-right: 0;
    }

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    .not-upload,
    .uploaded {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .not-upload {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        // margin-bottom: 5%;
        vertical-align: top;
        width: 20%;
        max-width: 38px;
      }

      p {
        color: @other-grey;
        font-size: 1rem;
        line-height: 1.2;
        margin: 5% 0;
        padding: 0 20px;
        text-align: center;
        white-space: pre-line;
      }

      // .el-button {
        // margin-top:f 5%;
        // width: 160px;
      // }
    }

    .uploaded {
      .el-image {
        width: 100%;
        height: 100%;
      }

      .el-button {
        position: absolute;
        width: 60px;
        height: auto;
        bottom: 20px;
        left: 50%;
        margin-left: -30px;
      }
    }
  }

  &.upload-btn {
    margin-left: 10px;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>